import { ReactComponent as Search } from '../../assets/svg/search.svg';

export default Search;
